import { fg } from '@atlaskit/platform-feature-flags/fg';
import { AnyAri, PlatformSiteAri } from '@atlassian/ari';

const SITE_RESOURCE_TYPE = 'site';

export const ACTIVITY_UNITS_CONTEXT_GATE = 'townsquare_activity_units_context';

/**
 * Creates a Platform site ARI from a site ID
 * Safely handles invalid siteIds by returning null on failure
 * @param siteId - The site ID
 * @returns The platform site ARI string in format "ari:cloud:platform::site/{siteId}", or null if creation fails
 */
export const createPlatformSiteAri = (siteId: string | null | undefined): string | null => {
	if (!siteId) {
		return null;
	}
	try {
		return PlatformSiteAri.create({ siteId }).toString();
	} catch {
		return null;
	}
};

/**
 * Activity Platform Units context (`collabContextId`) for a bare cloud id or a site ARI.
 * Townsquare and identity site ARIs are reduced to their site id before the platform ARI is built.
 * Returns undefined when `townsquare_activity_units_context` is off, or the id is missing, so callers omit the filter field.
 */
export const collabContextIdFromSite = (
	siteIdOrAri: string | null | undefined,
): string | undefined => {
	if (!fg(ACTIVITY_UNITS_CONTEXT_GATE) || !siteIdOrAri) {
		return undefined;
	}

	let siteId = siteIdOrAri;
	try {
		const ari = AnyAri.parse(siteIdOrAri);
		if (ari.resourceType === SITE_RESOURCE_TYPE) {
			siteId = ari.resourceId;
		}
	} catch {
		// A bare cloud id is not an ARI.
	}

	return createPlatformSiteAri(siteId) ?? undefined;
};
